import React from 'react';
import Button from '../../../../../../Components/Button/Button';
import { Theme } from '../../../../../../Enums/Theme.enum';
// @ts-ignore
import styles from './ManagerInsuranceCompaniesImportModalFooter.module.scss';

interface ManagerInsuranceCompaniesImportModalFooterProps {
	onSubmit: () => void;
}

const ManagerInsuranceCompaniesImportModalFooter = ({
	onSubmit,
}: ManagerInsuranceCompaniesImportModalFooterProps) => {
	return (
		<div className={styles.footerContent}>
			<Button
				title={'base.shared.add'}
				theme={Theme.GREEN}
				onClick={onSubmit}
			/>
		</div>
	);
};

export default ManagerInsuranceCompaniesImportModalFooter;
